import { memoryGraphStore, MemoryNode } from './memoryGraphStore';

/**
 * Memory Query Layer
 * Translates intent into weighted recommendations from the graph.
 */
export const memoryQuery = {
    // Finds the most visited/preferred venues for a given intent
    getRecommendationsForIntent(intent: string): MemoryNode[] {
        const intentId = `i_${intent.toLowerCase()}`;
        console.group(`[Memory] Querying context for: ${intent}`);
        
        const recs = memoryGraphStore.getRecommendations(intentId);
        
        if (recs.length > 0) {
            console.info(`Found ${recs.length} learned preferences.`);
            recs.forEach(r => console.info(`- Learned: ${r?.label} (Weight: ${r?.type})`));
        } else {
            console.warn("No learned preferences for this intent. Using local context only.");
        }
        
        console.groupEnd();
        return recs as MemoryNode[];
    },

    // Identifies frequently visited districts
    getPreferredDistricts(): string[] {
        const districts = memoryGraphStore.getNodesByType("district");
        return districts.map(d => d.label);
    }
};

if (typeof window !== 'undefined') {
    (window as any).WingmanMemoryQuery = memoryQuery;
}
